<template>
  <div>
    <v-tabs color="#7367F0" grow v-model="filterForm.assignContact">
      <v-tab @change="searchUser(0)"
      >Bật phân bổ</v-tab>

      <v-tab @change="searchUser(1)"
      >Tắt phân bổ</v-tab>
    </v-tabs>
    <validation-observer v-slot="{ handleSubmit }">
      <v-simple-table class="table-layout pa-5" v-if="listUserAllotment.length != 0">
      <template v-slot:default>
        <thead>
        <tr class="item-table-header">
          <th rowspan="2" class="border-table w-100-pixel">Phòng ban</th>
          <th rowspan="2" class="border-table w-100-pixel">Teams</th>
          <th rowspan="2" class="border-table">Nhân viên</th>
          <th rowspan="2" class="border-table min-width-90">Kho</th>
          <th rowspan="2" class="border-table min-width-90">Nguồn</th>
          <th colspan="2" class="border-table">Sáng</th>
          <th colspan="2" class="border-table">Chiều</th>
          <th colspan="2" class="border-table">Tối</th>
          <th rowspan="2" class="border-table min-width-200">Rule</th>
          <th rowspan="2" class="border-table min-width-fit">Status</th>
        </tr>
        <tr class="item-table-sub-header">
          <th class="border-table min-width-75 total-column">Tổng</th>
          <th class="border-table min-width-75">Phân bổ</th>
          <th class="border-table min-width-75 total-column">Tổng</th>
          <th class="border-table min-width-75">Phân bổ</th>
          <th class="border-table min-width-75 total-column">Tổng</th>
          <th class="border-table min-width-75">Phân bổ</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(user) in listUserAllotment">
          <tr
              :key="user.id"
              class="custom-v-table-tr"
          >
            <td class="border-table font-weight-bold"
                v-if="listOrgLv2MapRowspan['userId' + user.id]"
                :rowspan="listOrgLv2MapRowspan['userId' + user.id].rowspan"
            >
              {{ _.get(listOrgLv2MapRowspan['userId' + user.id], 'name') }}
            </td>
            <td class="border-table font-weight-bold"
                v-if="user.index == 0"
                :rowspan="user.rowSpan ? user.rowSpan : null"
            >
              {{user.departmentName}}
            </td>
            <td
                :rowspan="user.sources.length ? user.sources.length : null"
                class="border-table" > {{user.fullName}} </td>


            <td
                :rowspan="user.sources.length ? user.sources.length : null"
                class="border-table">
              <div>
                {{user.store | storeFilter}}
              </div>
            </td>

            <td class="border-table" v-if="user.sources.length">
              <div>
                {{user.sources[0].name}}
              </div>
            </td>
            <td class="border-table" v-else></td>

            <td
                :rowspan="user.sources.length ? user.sources.length : null"
                class="border-table total-column">
<!--              <div v-if="user.showEdit && user.showEdit.total_m">-->
<!--                <v-text-field-->
<!--                    v-model="user.showEdit.total_m"-->
<!--                    color="#7367F0"-->
<!--                    type="number"-->
<!--                    min="0"-->
<!--                    step="1"-->
<!--                    @change="updateAllotmentForUser(user)"-->
<!--                />-->
<!--              </div>-->
              <div>
                {{user.total_m}}
              </div>
            </td>

            <td :class="user.sources[0].isEdited.numberOfContactM ? 'border-table index-edited' : 'border-table'"
                v-if="user.sources.length"
                @dblclick="beforeEdit(user.sources[0], 'numberOfContactM')">
              <div v-if="user.sources[0].showEdit.numberOfContactM">
                <validation-provider
                    v-slot="{ errors }"
                    :rules="{required: user.isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"
                    name="Giá trị"
                    class="d-flex flex-wrap"
                >
                  <v-text-field
                      v-model="user.sources[0].numberOfContactM"
                      color="#7367F0"
                      :error-messages="errors"
                      @input="changeIndex(user, 'numberOfContactM')"
                      @keyup.enter="handleSubmit(updateAllotmentForUser(user, errors))"
                  />
                </validation-provider>
              </div>
              <div v-else>
                {{user.sources[0].numberOfContactM}}
              </div>
            </td>
            <td class="border-table" v-else></td>

            <td
                :rowspan="user.sources.length ? user.sources.length : null"
                class="border-table total-column">
<!--              <div v-if="user.showEdit && user.showEdit.total_a">-->
<!--                <v-text-field-->
<!--                    v-model="user.showEdit.total_a"-->
<!--                    color="#7367F0"-->
<!--                    type="number"-->
<!--                    min="0"-->
<!--                    step="1"-->
<!--                    @change="updateAllotmentForUser(user)"-->
<!--                />-->
<!--              </div>-->
              <div>
                {{user.total_a}}
              </div>
            </td>

            <td :class="user.sources[0].isEdited.numberOfContactA ? 'border-table index-edited' : 'border-table'"
                v-if="user.sources.length"
                @dblclick="beforeEdit(user.sources[0], 'numberOfContactA')">
              <div v-if="user.sources[0].showEdit.numberOfContactA">
                <validation-provider
                    v-slot="{ errors }"
                    :rules="{required: user.isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"
                    name="Giá trị"
                    class="d-flex flex-wrap"
                >
                  <v-text-field
                    v-model="user.sources[0].numberOfContactA"
                    color="#7367F0"
                    :error-messages="errors"
                    @input="changeIndex(user, 'numberOfContactA')"
                    @keyup.enter="handleSubmit(updateAllotmentForUser(user, errors))"
                  />
                </validation-provider>
              </div>
              <div v-else>
                {{user.sources[0].numberOfContactA}}
              </div>
            </td>
            <td class="border-table" v-else></td>

            <td
                :rowspan="user.sources.length ? user.sources.length : null"
                class="border-table total-column">
<!--              <div v-if="user.showEdit && user.showEdit.total_e">-->
<!--                <v-text-field-->
<!--                    v-model="user.showEdit.total_e"-->
<!--                    color="#7367F0"-->
<!--                    type="number"-->
<!--                    min="0"-->
<!--                    step="1"-->
<!--                    @change="updateAllotmentForUser(user)"-->
<!--                />-->
<!--              </div>-->
              <div>
                {{user.total_e}}
              </div>
            </td>

            <td :class="user.sources[0].isEdited.numberOfContactE ? 'border-table index-edited' : 'border-table'"
                v-if="user.sources.length"
                @dblclick="beforeEdit(user.sources[0], 'numberOfContactE')">
              <div v-if="user.sources[0].showEdit.numberOfContactE">
                <validation-provider
                    v-slot="{ errors }"
                    :rules="{required: user.isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"
                    name="Giá trị"
                    class="d-flex flex-wrap"
                >
                  <v-text-field
                      v-model="user.sources[0].numberOfContactE"
                      color="#7367F0"
                      :error-messages="errors"
                      @input="changeIndex(user, 'numberOfContactE')"
                      @keyup.enter="handleSubmit(updateAllotmentForUser(user, errors))"
                  />
                </validation-provider>
              </div>
              <div v-else>
                {{user.sources[0].numberOfContactE}}
              </div>
            </td>
            <td class="border-table" v-else></td>

<!--            <td-->
<!--                :rowspan="user.sources.length"-->
<!--                class="border-table">-->
<!--              {{ user.name }}-->
<!--            </td>-->

            <td
                :rowspan="user.sources.length ? user.sources.length : null"
                class="border-table">
              <div class="d-flex align-center">
                <div class="w-100">
                  <v-autocomplete
                      v-model="user.allotmentId"
                      color="#7367F0"
                      no-data-text="Không có dữ liệu"
                      :items="allotmentListForSelect"
                      item-text="name"
                      item-value="id"
                      hide-details
                      :readonly="!checkAuthorization('setting-contact_update')"
                      @change="changeAllotmentForUser(user)"
                      class="pt-0"
                  />
                </div>
                <div
                    class="ml-2"
                    style="width: fit-content;"
                    v-if="user.isEditedIndexOfAllotment && checkAuthorization('setting-contact_update')">
                  <v-icon
                      @click="changeAllotmentForUser(user)"
                      color="red">mdi-cached</v-icon>
                </div>
              </div>
            </td>

            <td :rowspan="user.sources.length ? user.sources.length : null"
                class="border-table">
              <div style="width: 85px; margin: 0 auto">
                <v-switch
                    v-model="user.assignContact"
                    inset
                    color="#7367F0"
                    @change="changeStatusAssignForUser(user)"
                    class="switch-assign"
                    :disabled="!checkAuthorization('setting-contact_update')"
                />
              </div>
            </td>

          </tr>

          <template v-for="(itemSource, index) in user.sources">
            <tr v-if="index > 0">
              <td class="border-table">
                <div>
                  {{itemSource.name}}
                </div>
              </td>
              <td :class="itemSource.isEdited.numberOfContactM ? 'border-table index-edited' : 'border-table'"
                  @dblclick="beforeEdit(itemSource, 'numberOfContactM')">
                <div v-if="itemSource.showEdit.numberOfContactM">
                  <validation-provider
                      v-slot="{ errors }"
                      :rules="{required: user.isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"
                      name="Giá trị"
                      class="d-flex flex-wrap"
                  >
                    <v-text-field
                        v-model="itemSource.numberOfContactM"
                        color="#7367F0"
                        :error-messages="errors"
                        @input="changeIndex(user, 'numberOfContactM')"
                        @keyup.enter="handleSubmit(updateAllotmentForUser(user, errors))"
                    />
                  </validation-provider>
                </div>
                <div v-else>
                  {{itemSource.numberOfContactM}}
                </div>
              </td>
              <td :class="itemSource.isEdited.numberOfContactA ? 'border-table index-edited' : 'border-table'"
                  @dblclick="beforeEdit(itemSource, 'numberOfContactA')">
                <div v-if="itemSource.showEdit.numberOfContactA">
                  <validation-provider
                      v-slot="{ errors }"
                      :rules="{required: user.isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"
                      name="Giá trị"
                      class="d-flex flex-wrap"
                  >
                    <v-text-field
                        v-model="itemSource.numberOfContactA"
                        color="#7367F0"
                        :error-messages="errors"
                        @input="changeIndex(user, 'numberOfContactA')"
                        @keyup.enter="handleSubmit(updateAllotmentForUser(user, errors))"
                    />
                  </validation-provider>
                </div>
                <div v-else>
                  {{itemSource.numberOfContactA}}
                </div>
              </td>
              <td :class="itemSource.isEdited.numberOfContactE ? 'border-table index-edited' : 'border-table'"
                  @dblclick="beforeEdit(itemSource, 'numberOfContactE')">
                <div v-if="itemSource.showEdit.numberOfContactE">
                  <validation-provider
                      v-slot="{ errors }"
                      :rules="{required: user.isRequired, numeric: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100}"
                      name="Giá trị"
                      class="d-flex flex-wrap"
                  >
                    <v-text-field
                        v-model="itemSource.numberOfContactE"
                        color="#7367F0"
                        :error-messages="errors"
                        @input="changeIndex(user, 'numberOfContactE')"
                        @keyup.enter="handleSubmit(updateAllotmentForUser(user, errors))"
                    />
                  </validation-provider>
                </div>
                <div v-else>
                  {{itemSource.numberOfContactE}}
                </div>
              </td>
            </tr>

          </template>
        </template>
        </tbody>
      </template>
    </v-simple-table>
    </validation-observer>
    <common-no-result
        v-if="listUserAllotment.length === 0"
    />
  </div>
</template>

<script>
export default {
  props: {
    listUserAllotment: {
      type: Array,
      default: () => {[]}
    },
    allotmentList: {
      type: Array,
      default: () => {[]}
    },
    filterForm: {
      type: Object,
      default: () => {}
    },
    listOrgLv2MapRowspan: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    storeFilter(value) {
      if (value == 'T') {
        return 'Kho T'
      } else if (value == 'C') {
        return 'Kho C'
      } else if (value == 'M') {
        return 'Kho M'
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      stores: [
        {
          name: 'Kho T',
          value: 'T'
        },
        {
          name: 'Kho C',
          value: 'C'
        },
        {
          name: 'Kho G',
          value: 'G'
        },
        {
          name: 'Kho M',
          value: 'M'
        }
      ],
      assignContacts: [
        {
          name: 'Tự động',
          value: 'true'
        },
        {
          name: 'Không tự động',
          value: 'false'
        }
      ],
      allotmentListForSelect: []
    }
  },
  watch: {
    allotmentList: {
      handler () {
        this.allotmentListForSelect = _.cloneDeep(this.allotmentList);
        this.allotmentListForSelect.unshift({
          id: null,
          name: '--- Không chọn lộ trình ---'
        })
      }
    }
  },
  methods: {
    updateAllotmentForUser(user, errors) {
      if(!errors.length) {
        Bus.$emit('update-user-allotment-contact', user)
      }
    },
    changeAllotmentForUser(user) {
      Bus.$emit('change-user-allotment-user', user)
    },
    changeStatusAssignForUser(user) {
      Bus.$emit('change-status-assign-user', user)
    },
    beforeEdit(user, param) {
      if(user.showEdit && this.checkAuthorization('setting-contact_update')) {
        user.showEdit[param] = !user.showEdit[param]
      }
    },
    searchUser(status) {
      this.filterForm.assignContact = +status
      Bus.$emit('search-user-allotment-contact', this.filterForm)
    },
    // beforeEditAllotment(user) {
    //   user.showEditAllotment = !user.showEditAllotment
    // },
    changeIndex(user, property) {
      let totalChange = '';
      switch (property) {
        case 'numberOfContactM':
          totalChange = 'total_m'
          break;
        case 'numberOfContactA':
          totalChange = 'total_a'
          break;
        case 'numberOfContactE':
          totalChange = 'total_e'
          break;
      }

      user[totalChange] = user.sources.reduce( (total, item) => {
        return total + (+item[property]);
      }, 0)
      user.isRequired = !user.total_m && !user.total_a && !user.total_e
    }
  }
}
</script>

<style scoped>
/deep/.switch-assign.v-input--switch--inset .v-input--switch__thumb {
  transform: translate(0px, 0px) !important;
  width: 12px !important;
  height: 12px !important;
}
/deep/.switch-assign.v-input--switch--inset.v-input--is-dirty .v-input--switch__thumb {
  transform: translate(60px, 0px) !important;
  width: 12px !important;
  height: 12px !important;
}
/deep/.switch-assign.v-input--switch--inset .v-input--selection-controls__ripple {
  transform: translate(3px, 3px) !important;
  width: 20px !important;
  height: 20px !important;
}
/deep/.switch-assign.v-input--switch--inset.v-input--is-dirty .v-input--selection-controls__ripple {
  transform: translate(63px, 3px) !important;
  width: 20px !important;
  height: 20px !important;
}
/deep/.switch-assign.v-input--switch--inset .v-input--switch__track {
  width: 80px !important;
  height: 20px !important;
}
/deep/ table tbody tr {
  height: 30px !important;
}
/deep/ table thead tr {
  height: 45px !important;
}
/deep/ table tbody tr td {
  height: 45px !important;
  padding: 0px 8px !important
}
/deep/ table thead tr th {
  height: 30px !important;
  padding: 0px 8px !important;
}
.switch-assign {
  height: 24px;
  margin-top: 0px !important;
}
/deep/.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none !important;
}
div.v-tab {
  width: 50%;
  padding-left: 5px;
}
.index-edited {
  color: red;
  font-weight: bold;
}
/deep/.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  height: 21px;
}
/deep/.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  text-align: center;
}
/deep/.min-width-75 {
  min-width: 75px;
}
/deep/.min-width-200 {
  min-width: 200px;
}
/deep/.min-width-fit {
  min-width: fit-content;
}
/deep/.min-width-90 {
  min-width: 90px;
}
/deep/ .w-100 {
  width: 100%;
}
/deep/ .w-100-pixel {
  width: 100px;
}
.item-table-header {
  background: rgba(43, 1, 132, 0.5);;
}
.item-table-header th {
  color: white !important;
  border-color: white;
}
.item-table-sub-header th {
  font-weight: bold !important;
}
.total-column {
  background-color: rgba(153, 138, 215, 0.2);;
}
</style>